import { render, staticRenderFns } from "./EchartsColumn.vue?vue&type=template&id=5841b574&scoped=true&"
import script from "./EchartsColumn.vue?vue&type=script&lang=ts&"
export * from "./EchartsColumn.vue?vue&type=script&lang=ts&"
import style0 from "./EchartsColumn.vue?vue&type=style&index=0&id=5841b574&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5841b574",
  null
  
)

export default component.exports